import React, { useEffect } from 'react';

const Section = ({ title, children }) => (
  <section>
    <h2 className="text-xl font-bold text-slate-900 mb-3">{title}</h2>
    <div className="space-y-3">{children}</div>
  </section>
);

const PrivacyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Privacy Policy | DigitalGigs';
  }, []);

  const openCookieSettings = () => window.dispatchEvent(new Event('dg:open-cookie-settings'));

  return (
    <main className="pt-36 pb-24 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-emerald-600 font-black text-sm uppercase tracking-[0.2em] mb-4">Datenschutzerklärung</p>
        <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 tracking-tight mb-4">Privacy Policy</h1>
        <p className="text-slate-500 font-medium mb-12">Last updated: October 2026</p>

        <div className="space-y-10 text-slate-600 font-medium leading-relaxed">
          <Section title="1. Controller">
            <p>
              Ajedolabomi Olatifewa Okulaja, DigitalGigs, Klemensgasse 5A, 56856 Zell (Mosel), Germany.<br />
              Email:{' '}
              <a href="mailto:digitalgig24@gmail.com" className="text-emerald-600 font-bold hover:text-emerald-700">
                digitalgig24@gmail.com
              </a>
            </p>
          </Section>

          <Section title="2. Hosting">
            <p>
              This website is hosted by Netlify, Inc., 101 2nd Street, San Francisco, CA 94105, USA. When you visit the
              website, the server automatically records technical data in log files, such as your IP address, browser type,
              operating system, referring page and the date and time of access. This is necessary to deliver the website
              securely and reliably (Art. 6(1)(f) GDPR). Data may be processed in the USA; Netlify relies on the EU
              Standard Contractual Clauses.
            </p>
          </Section>

          <Section title="3. Contact by email and WhatsApp">
            <p>
              If you contact us by email or WhatsApp, we process the data you send us (e.g. name, phone number, email
              address and your message) only to answer your enquiry and, where relevant, to prepare or carry out a contract
              (Art. 6(1)(b) GDPR). Our email is provided by Google (Gmail). WhatsApp is operated by WhatsApp Ireland Ltd.
              (Meta); data may be transferred to the USA. We delete enquiry data once it is no longer needed, unless legal
              retention periods apply.
            </p>
          </Section>

          <Section title="4. Forms on this website">
            <p>
              Some pages (e.g. job opportunities or AI video requests) contain forms. The data you enter is stored in a
              Google Sheets spreadsheet (Google Ireland Ltd.) so that we can process your request or application
              (Art. 6(1)(b) GDPR). We delete it once the request is completed, unless legal retention periods apply.
            </p>
          </Section>

          <Section title="5. Google Ads conversion tracking">
            <p>
              With your consent (Art. 6(1)(a) GDPR, § 25(1) TDDDG) we use Google Ads conversion tracking from Google Ireland
              Ltd., Gordon House, Barrow Street, Dublin 4, Ireland. It helps us see whether a visit that came from one of our
              ads led to an enquiry (for example a click on our WhatsApp or email link). For this, cookies or similar
              technologies are stored on your device and data such as your IP address, device information and the ad click
              are sent to Google.
            </p>
            <p>
              We use Google Consent Mode: until you click &quot;Accept&quot; in our cookie banner, no advertising cookies
              are set. Data may be transferred to the USA; Google LLC is certified under the EU-US Data Privacy Framework.
            </p>
            <p>
              You can withdraw your consent at any time with effect for the future via{' '}
              <button type="button" onClick={openCookieSettings} className="text-emerald-600 font-bold hover:text-emerald-700 underline">
                Cookie settings
              </button>
              .
            </p>
          </Section>

          <Section title="6. Storage of your cookie choice">
            <p>
              We save your cookie choice in your browser&apos;s local storage so that we do not ask again on every visit.
              This is technically necessary (§ 25(2) TDDDG).
            </p>
          </Section>

          <Section title="7. Your rights">
            <p>
              You have the right to access (Art. 15 GDPR), rectification (Art. 16), erasure (Art. 17), restriction of
              processing (Art. 18), data portability (Art. 20) and to object to processing based on legitimate interests
              (Art. 21). You can withdraw any consent at any time (Art. 7(3)). To exercise these rights, simply email us.
            </p>
            <p>
              You also have the right to lodge a complaint with a data protection supervisory authority, for example the
              authority responsible for us: Der Landesbeauftragte für den Datenschutz und die Informationsfreiheit
              Rheinland-Pfalz.
            </p>
          </Section>
        </div>
      </div>
    </main>
  );
};

export default PrivacyPage;
